import {
  APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_BEGIN,
  APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_SUCCESS,
  APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_FAILURE,
  APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function deleteLocalizationKeyValue(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_BEGIN,
    });
    const { projectId, key } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}localization/deleteKeyandValue/${key}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_SUCCESS,
              data: res.data,
            });
            toast.success('Deleted Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteLocalizationKeyValueError() {
  return {
    type: APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_BEGIN:
      return {
        ...state,
        deleteLocalizationKeyValuePending: true,
        deleteLocalizationKeyValueError: null,
      };

    case APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_SUCCESS:
      return {
        ...state,
        deleteLocalizationKeyValuePending: false,
        deleteLocalizationKeyValueError: null,
        localization: action.data,
      };

    case APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_FAILURE:
      return {
        ...state,
        deleteLocalizationKeyValuePending: false,
        deleteLocalizationKeyValueError: action.data.error,
      };

    case APP_SETTING_DELETE_LOCALIZATION_KEY_VALUE_DISMISS_ERROR:
      return {
        ...state,
        deleteLocalizationKeyValueError: null,
      };

    default:
      return state;
  }
}
